import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HjpTabView = _resolveComponent("HjpTabView")!
  const _component_PositionTab = _resolveComponent("PositionTab")!
  const _component_RequirementTab = _resolveComponent("RequirementTab")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, { class: "card-no-shadow wrap-hjp-data-table" }, {
      content: _withCtx(() => [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-2xl mb-20px" }, _toDisplayString('Master Divisi'), -1)),
        _createVNode(_component_HjpTabView, {
          tabHeader: _ctx.arrayTab,
          currActive: _ctx.currentTab,
          onTabsChange: _ctx.tabChange
        }, null, 8, ["tabHeader", "currActive", "onTabsChange"]),
        (_ctx.currentTab === 0)
          ? (_openBlock(), _createBlock(_component_PositionTab, { key: 0 }))
          : (_ctx.currentTab === 1)
            ? (_openBlock(), _createBlock(_component_RequirementTab, { key: 1 }))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}